/** Shared by the CRM error matcher and validation toasts. No Angular imports. */

export const COMPLETE_REQUIRED_FIELDS = 'Please complete the required fields';

export type ErrorTree = {
  enabled: boolean;
  invalid: boolean;
  controls?: Record<string, ErrorTree> | ErrorTree[];
};

/** Red border after edit, real submit, or Next/Save — not after tabbing past an empty field. */
export function showsSubmittedError(state: {
  invalid: boolean;
  dirty: boolean;
  submitted: boolean;
  revealed: boolean;
}): boolean {
  return state.invalid && (state.dirty || state.submitted || state.revealed);
}

/** How many enabled leaf controls are currently invalid. */
export function invalidLeafCount(control: ErrorTree): number {
  const children = childControls(control);
  if (children) {
    return children.reduce((sum, child) => sum + invalidLeafCount(child), 0);
  }
  return control.enabled && control.invalid ? 1 : 0;
}

/**
 * One invalid field can name itself. Several should not — the toast would
 * look like only that field failed.
 */
export function requiredFieldsNotice(control: ErrorTree, whenSingle: string): string {
  return invalidLeafCount(control) > 1 ? COMPLETE_REQUIRED_FIELDS : whenSingle;
}

function childControls(control: ErrorTree): ErrorTree[] | null {
  const children = control.controls;
  if (!children) return null;
  return Array.isArray(children) ? children : Object.values(children);
}
